module.exports = __webpack_public_path__ + "static/img/031治疗单-患者.02bb845.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/031治疗单-患者.jpg
// module id = EjUu
// module chunks = 0